import { useMemo } from "react";

import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import Tag from "components/Tags/CustomTag";
import { Flex, Text } from "@chakra-ui/react";
import { OperacaoEnum } from "resources/enums/conta";
import { MdOutlineHomeWork } from "react-icons/md";
import type { ColumnsType } from "antd/es/table";
import { ContaParaExtratoBancarioResponse } from "features/conciliacao-bancaria/typings";
import { TipoDataConta } from "core/features/conta/typings";

function useContaTableColumns(
  operacao?: OperacaoEnum,
  tipoData?: TipoDataConta
) {
  return useMemo((): ColumnsType<ContaParaExtratoBancarioResponse> => {
    return [
      {
        title:
          tipoData === "movimentacao"
            ? "Data de crédito"
            : "Data de vencimento",
        width: "125px",
        render: (item: ContaParaExtratoBancarioResponse) =>
          tipoData === "movimentacao"
            ? moment(item.dataMovimentacao).format("DD/MM/YYYY")
            : moment(item.dataVencimento).format("DD/MM/YYYY"),
      },
      {
        title: "Descrição",
        dataIndex: "descricao",
      },
      {
        title: operacao === OperacaoEnum.Despesa ? "Fornecedor" : "Devedor",
        render: ({
          pessoa,
          unidade,
          transferenciaId,
        }: ContaParaExtratoBancarioResponse) => (
          <Flex flexDir="column">
            {unidade ? (
              <Flex gap="8px" alignItems={"center"}>
                <MdOutlineHomeWork /> <Text fontWeight="bold">{unidade}</Text>
              </Flex>
            ) : null}
            {pessoa ? <Text>{pessoa}</Text> : null}
            {transferenciaId ? (
              <Tag
                mt="4px"
                h="25px"
                bg="gray.100"
                w="85px"
                color="gray.600"
                fontSize="10px"
                textAlign="center"
              >
                Transferência
              </Tag>
            ) : null}
          </Flex>
        ),
      },
      {
        title: "Valor",
        render: ({
          statusBoletoId,
          ...original
        }: ContaParaExtratoBancarioResponse) => (
          <Flex justifyContent="flex-end" alignItems="center">
            <Flex flex={1} flexDir="column">
              <Flex fontWeight="bold">
                {formatMoney(original.valorLiquido)}
              </Flex>
            </Flex>
            {original.dataPagamento ? (
              <Flex>
                <Flex gap="8px" justifyContent="flex-end">
                  <Tag
                    h="25px"
                    bg="green.600"
                    minW="85px"
                    color="white"
                    fontSize="10px"
                    textAlign="center"
                  >
                    Pago {moment(original.dataPagamento).format("DD/MM")}
                  </Tag>
                </Flex>
              </Flex>
            ) : null}
          </Flex>
        ),
      },
    ];
  }, [operacao, tipoData]);
}

export default useContaTableColumns;
